import { render, staticRenderFns } from "./Lgx335452482824044544.vue?vue&type=template&id=99d683c2&scoped=true&"
import script from "./Lgx335452482824044544.vue?vue&type=script&lang=js&"
export * from "./Lgx335452482824044544.vue?vue&type=script&lang=js&"
import style0 from "./Lgx335452482824044544.vue?vue&type=style&index=0&id=99d683c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d683c2",
  null
  
)

export default component.exports